import {
  HighlightedCombine,
  HighlightedProduct,
} from "src/features/highlighted-product/model/HighlightedProduct";

const getCombinedDetail = (
  data: HighlightedCombine,
  displayIndex: number = 0
) => {
  const { name: combinedName } = data;
  const combinedCount = data?.products?.length;
  const thumbnails = data.products
    .map((product, index) => {
      return {
        displayIndex: index,
        imageUrl: product?.imageUrl,
      };
    })
    .filter((product, index) => index !== displayIndex);

  // get the highest and lowest price
  const highestPrice = Math.max(
    ...data.products.map((product: HighlightedProduct) => +product?.price)
  );
  const lowestPrice = Math.min(
    ...data.products.map((product: HighlightedProduct) => +product?.price)
  );
  // put it in a tuple
  const priceRange: [number, number] = [lowestPrice, highestPrice];

  return {
    combinedName,
    combinedCount,
    thumbnails,
    priceRange,
  };
};

export default getCombinedDetail;
